import { render } from "./CreateConfigYmirInternational.vue?vue&type=template&id=4e089597&scoped=true"
import script from "./CreateConfigYmirInternational.vue?vue&type=script&lang=js"
export * from "./CreateConfigYmirInternational.vue?vue&type=script&lang=js"

import "./CreateConfigYmirInternational.vue?vue&type=style&index=0&id=4e089597&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e089597"]])

export default __exports__